<template>
  <div class="step-one">
        <ol>
          <li class="form-group" autofocus v-bind:class="{ 'invalid-field': (createdObject.name == '' && !validate['step1']) }">
            <label for="name" class="control-label">Name</label>
            <div class="input-box">
              <input type="text" class="form-control" id="name" v-model="modelName" @input="createdObject.name = modelName" :disabled="modelType === 'view'"><span class="input-tips">(e.g. AB inBev | UK | Sales Ecosystem | optimised version)</span>
              <div class="error-msg">This is a required field.</div>
            </div>
          </li>
          <li class="form-group" v-bind:class="{ 'invalid-field': (createdObject.country == '' && !validate['step1']) }">
            <label for="country" class="control-label">Country</label>
            <div class="input-box">
              <select  v-model="selectedCountry" class="form-control" id="country" @change="countryChanged($event.target.value)" :disabled="modelType === 'view'">
                <option v-if="modelType === 'view'" selected>{{viewObject.country}}</option>
                <option v-else selected v-bind:value="false">Select Country</option>
                <option v-for="country in inputData" v-bind:value="country.Country">{{ country.Country }}</option>
              </select>
              <div class="error-msg">This is a required field.</div>
            </div>
            <div class="SelectedCurrency" v-if="selectedCountry.length !== 0">The Default Currency is {{SelectedCurrency}} </div>
          </li>
          <li class="form-group" v-bind:class="{ 'invalid-field': (createdObject.market == '' && !validate['step1']) }">
            <label for="category" class="control-label">Category</label>
            <div class="input-box">
              <select class="form-control" id="category" v-on:change="categoryChanged($event.target.value)" :disabled="modelType === 'view'">
                <option v-if="modelType === 'view'" selected>{{viewObject.category}}</option>
                <option v-else selected v-bind:value="false">Select Category</option>
                <option v-for="category in SelectedCategories" v-model="category.Category">{{category.Category}}</option>
              </select>
              <div class="error-msg">This is a required field.</div>
            </div>
          </li>
          <li class="form-group" v-bind:class="{ 'invalid-field': (createdObject.KPI == '' && !validate['step1']) }">
            <label for="KPI" class="control-label">KPI</label>
            <div class="input-box">
              <input type="text" class="form-control" v-model="modelKPI" @input="createdObject.KPI = modelKPI" id="KPI" :disabled="modelType === 'view'">
              <div class="error-msg">This is a required field.</div>
            </div>
          </li>
          <li class="form-group" v-bind:class="{ 'invalid-field': (createdObject.nests.length < 2 && !validate['step1']) }">
            <label for="earned-media" class="control-label">Owned/Earned Media</label>
            <div class="input-box">
                <!--multiselect :options="SelectedEarnedMedia" @remove="removeEarnedMedia" :multiple="true" :max="10" placeholder="Add More">
                </multiselect-->
                <multiselect :options="SelectedEarnedMedia" v-model="EarnedMediaValue" :multiple="true" @select="GetEarnedMedia" @remove="removeEarnedMedia" :close-on-select="false" :clear-on-select="false" :max="10" :searchable="false" placeholder="Add More" :disabled="modelType === 'view'">
                </multiselect>
                <div class="error-msg">This is a required field.</div>
            </div>
          </li>
          <li class="form-group" v-bind:class="{ 'invalid-field': (annualSpend['Channels'].length == 0 && !validate['step1']) }">
            <label for="earned-media" class="control-label">Paid Media</label>
            <div class="input-box">
                <multiselect :options="SelectedPaidMedia" v-model="PaidMediaValue" @select="GetPaidMedia" @remove="removePaidMedia" :multiple="true" :close-on-select="false" :clear-on-select="false"  :max="10" :searchable="false" placeholder="Add More" :disabled="modelType === 'view'">
                </multiselect>
                <div class="error-msg">This is a required field.</div>
            </div>
          </li>
        </ol>
      </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data () {
    return {
      modelName: '',
      modelKPI: '',
      EarnedMediaValue: '',
      PaidMediaValue: '',
      SelectedCategories: [],
      SelectedPaidMedia: [],
      SelectedEarnedMedia: [],
      selectedCountry: [],
      SelectedCurrency: '',
      annualSpend: this.createdObject.initial_annual_spend['table-data'],
      ccsReach: this.createdObject.ccs['table-data']
    }
  },
  watch: {
    viewObject: function () {
      if (this.modelType === 'view') {
        this.updateView()
      }
    }
  },
  methods: {
    countryChanged (selectedValue) {
      this.SelectedEarnedMedia = []
      if (selectedValue !== 'false') {
        this.SelectedCategories = this.inputData[selectedValue].Category
        this.SelectedCurrency = this.inputData[selectedValue].currency
        if (this.inputData[selectedValue].Paid_Media.indexOf('Press') !== -1) {
          let pressIndex = this.inputData[selectedValue].Paid_Media.indexOf('Press')
          this.SelectedPaidMedia = this.inputData[selectedValue].Paid_Media
          this.SelectedPaidMedia.splice(pressIndex, 1, 'Print')
        } else {
          this.SelectedPaidMedia = this.inputData[selectedValue].Paid_Media
        }
        this.createdObject.country = selectedValue
      } else {
        this.SelectedCategories = []
        this.SelectedMediaChannel = []
        this.createdObject.country = ''
        this.createdObject.market = ''
        alert('Please Select the Country')
        return false
      }
    },
    categoryChanged (selectedValue) {
      if (selectedValue !== 'false') {
        this.SelectedEarnedMedia = this.SelectedCategories[selectedValue].Media.filter(value => { return value !== 'Sales' })
        this.createdObject.market = selectedValue
      } else {
        this.SelectedEarnedMedia = []
        this.createdObject.market = ''
        alert('Please Select the Category')
        return false
      }
    },
    GetEarnedMedia (value) {
      this.createdObject.nests.push(value)
    },
    removeEarnedMedia (removedOption) {
      let filteredEarnedMedia = this.createdObject.nests.filter(
        value => {
          return value !== removedOption
        }
      )
      this.createdObject.nests = filteredEarnedMedia
    },
    GetPaidMedia (value) {
      if (value === 'Print') {
        value = 'Press'
      }
      this.annualSpend['Channels'].push(value.trim())
      this.ccsReach['Channels'].push(value.trim())
    },
    removePaidMedia (removedOption) {
      if (removedOption === 'Print') {
        removedOption = 'Press'
      }
      let removeSpendIndex = this.ccsReach['Channels'].indexOf(removedOption)
      for (let ccs in this.ccsReach) {
        if (this.ccsReach[ccs].length > removeSpendIndex) {
          this.ccsReach[ccs].splice(removeSpendIndex, 1)
        }
      }
      let removeCcsIndex = this.annualSpend['Channels'].indexOf(removedOption)
      for (let spend in this.annualSpend) {
        if (this.annualSpend[spend].length > removeCcsIndex) {
          this.annualSpend[spend].splice(removeCcsIndex, 1)
        }
      }
    },
    updateView () {
      this.modelName = this.viewObject.name
      this.modelKPI = this.viewObject.KPI
      this.EarnedMediaValue = this.viewObject.Nests
      this.selectedCountry = this.viewObject.country
      this.SelectedCurrency = this.viewObject.currency
      this.PaidMediaValue = []
      for (let key in this.viewObject.AnnualSpend) {
        this.PaidMediaValue.push(key)
      }
    }
  }
}
</script>

<style lang="css" >
.step-one li {
  position: relative;
}
.SelectedCurrency {
    position: absolute;
    left: 31%;
    border: 2px solid #fac600;
    padding: 10px;
    top: -10px;
    border-radius: 10px;
    background-color: #fbfbfb;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// Model-one.vue?2d728b05